import React from 'react';

export const CloseIcon = ({ onClick = () => {} }) => {
  return (
    <span onClick={onClick} className={'cursor-pointer'}>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
        <path d="M1 0.5L9 8.5M9 0.5L1 8.5" stroke="#E50505" strokeLinecap="round" />
      </svg>
    </span>
  );
};
